export default __webpack_public_path__ + "static/media/yeopen_main_large.8439b34e.jpg";